import { AlignmentType } from 'docx';
import * as quillToWord from 'quill-to-word';
import { CONTRAST_COLOR } from './item.util';

export const quillToWordConfig: quillToWord.Config = {
  exportAs: 'blob',
  paragraphStyles: {
    normal: {
      paragraph: {
        spacing: {
          before: 100,
          after: 100
        }
      },
      run: {
        font: 'Raleway',
        size: 24
      }
    },
    header_1: {
      run: {
        size: 38,
        bold: true,
        color: CONTRAST_COLOR.slice(1),
        font: 'Raleway'
      }
    },
    header_2: {
      run: {
        size: 30,
        bold: true,
        color: CONTRAST_COLOR.slice(1),
        font: 'Raleway'
      }
    },
    list_paragraph: {
      run: {
        font: 'Raleway'
      }
    }
  }
};
